import React, { useEffect, useState, useMemo } from "react"; // 1. useMemo eklendi
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row, Tooltip, Card, Statistic } from "antd"; // 2. Card ve Statistic eklendi (Görsellik için)
import {
  OrderedListOutlined,
  RollbackOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockTransactionProjectTypeReportFilter from "../Filters/StockTransactionProjectTypeReportFilter";
import CurrencyFormat from "react-currency-format";

const StockTransactionProjectTypeReport = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "DEPO STOK RAPORU",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    let { skip, take, filter } = tableDataQueryOptions;
    take = 1000;
    const order = "&$orderby=name asc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/StockTransactionProjectType?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        loading: false,
        total: response["@odata.count"] || 0,
      });
    });
  };

  // --- 3. DİP TOPLAM HESAPLAMA MANTIĞI BURAYA EKLENDİ ---
  const grandTotals = useMemo(() => {
    if (!tableData.data || tableData.data.length === 0) return [];

    // Gelen veriyi Birim'e (unit) göre grupla ve Count'ları topla
    const totalsMap = tableData.data.reduce((acc, item) => {
      // Önce null kontrolü yap, varsa küçült, yoksa "belirsiz" ata
      const rawUnit = item.unit;

      // Türkçe karakter (İ, I, Ş vb.) desteğiyle küçük harfe çeviriyoruz
      const unitKey = rawUnit ? rawUnit.toLocaleUpperCase("tr-TR") : "belirsiz";

      const count = item.count || 0;

      if (!acc[unitKey]) {
        acc[unitKey] = 0;
      }
      acc[unitKey] += count;
      return acc;
    }, {});

    // Object'i array'e çeviriyoruz
    return Object.keys(totalsMap).map((unitKey) => ({
      unit: unitKey, // Çıktı artık tamamen küçük harf olacaktır (örn: "adet")
      total: totalsMap[unitKey],
    }));
  }, [tableData.data]);
  // -----------------------------------------------------

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Depo Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => {
        if (!text) return "";

        const shortText =
          text.length <= 50 ? text : text.substring(0, 50) + "...";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Tooltip title={text}>{shortText}</Tooltip>
            {record.isMain && (
              <Tooltip title="Ana Depo">
                <CheckCircleOutlined style={{ color: "green" }} />
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      title: "Depo Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "center",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "center",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.substring(0, 20)?.length < 20
                ? text?.substring(0, 20) + ""
                : text?.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "center",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.substring(0, 20)?.length < 20
                ? text?.substring(0, 20) + ""
                : text?.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Birimi",
      dataIndex: "unit",
      key: "unit",
      align: "center",
    },
    {
      title: "Stok Adedi",
      dataIndex: "count",
      key: "count",
      align: "center",
      render: renderDecimal,
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>

        <Col xs={24} md={12} lg={8}>
          {/* --- 4. DİP TOPLAM GÖRSEL ALANI --- */}
          {grandTotals.length > 0 && (
            <Row justify="end" style={{ marginRight: "1%" }}>
              <Col>
                <Card
                  size="small"
                  title="Dip Toplam"
                  style={{
                    borderColor: "#d9d9d9",
                    background: "#f9f9f9",
                    minWidth: 300,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                  headStyle={{ backgroundColor: "#fafafa", fontWeight: "bold" }}
                >
                  {grandTotals.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom:
                          index !== grandTotals.length - 1
                            ? "1px solid #f0f0f0"
                            : "none",
                        padding: "8px 0",
                      }}
                    >
                      <span style={{ fontWeight: 500, color: "#555" }}>
                        {item.unit}:
                      </span>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.1em",
                          color: "#1890ff",
                        }}
                      >
                        {/* Antd'nin kendi formatı veya senin ColumnHelper'ını kullanabilirsin. 
                        Burada standart JS formatı kullandım, senin ColumnHelper'ın string döndürüyorsa onu da çağırabilirsin. */}
                        {item.total.toLocaleString("tr-TR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  ))}
                </Card>
              </Col>
            </Row>
          )}
          {/* ---------------------------------- */}
        </Col>
      </Row>
      <StockTransactionProjectTypeReportFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        stockId={props.match.params.stockId}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: 100,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockTransactionProjectTypeReport;
